import { ALargeSmall } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LOCAL_KEYS } from '../constants/storageKeys'
import { safeLocalStorage } from '../utils/safeStorage'
import '../css/FontSizeToggle.css'

const SCALE_STEPS = [1, 1.15, 1.3]

const FontSizeToggle = () => {
	const { t } = useTranslation('common')
	const [stepIndex, setStepIndex] = useState(() => {
		const stored = parseInt(safeLocalStorage.getItem(LOCAL_KEYS.FONT_SCALE), 10)
		return Number.isInteger(stored) && stored >= 0 && stored < SCALE_STEPS.length ? stored : 0
	})

	useEffect(() => {
		document.documentElement.style.fontSize = `${16 * SCALE_STEPS[stepIndex]}px`
		safeLocalStorage.setItem(LOCAL_KEYS.FONT_SCALE, String(stepIndex))
	}, [stepIndex])

	const cycle = () => setStepIndex(prev => (prev + 1) % SCALE_STEPS.length)
	const percent = Math.round(SCALE_STEPS[stepIndex] * 100)

	return (
		<button
			type='button'
			className='font-size-toggle'
			onClick={cycle}
			aria-label={t('header.fontSize', { percent })}
			title={t('header.fontSize', { percent })}
		>
			<ALargeSmall size={20} strokeWidth={2.25} />
			<span className='font-size-toggle-dots' aria-hidden='true'>
				{SCALE_STEPS.map((_, i) => (
					<span key={i} className={`font-size-toggle-dot ${i === stepIndex ? 'active' : ''}`} />
				))}
			</span>
		</button>
	)
}

export default FontSizeToggle
